import {
    LOGIN_USER,
    AUTH_USER,
    LOGOUT_USER,
    HOME_REALTIME,
    HOME_GRAPH,
    HOME_STATUS_RESET,
    HOME_GRAPH_PRINT,
    SETTING_ALERT_UPDATE,
    SETTING_TERM_UPDATE
} from '../_actions/types';

export default function (state = {}, action) {
    switch (action.type) {
        case LOGIN_USER:
            return { ...state, loginSuccess: action.payload }
        case AUTH_USER:
            return { ...state, userData: action.payload }
        case LOGOUT_USER:
            return { ...state, logoutSuccess: action.payload }
        case HOME_REALTIME:
            return { ...state, findSuccess: action.payload }
        case HOME_GRAPH:
            return { ...state, findSuccess: action.payload }
        case HOME_STATUS_RESET:
            return { ...state, doSuccess: action.payload }
        case HOME_GRAPH_PRINT:
            return { ...state, findSuccess: action.payload }
        case SETTING_ALERT_UPDATE:
            return { ...state, updateSuccess: action.payload }
        case SETTING_TERM_UPDATE:
            return { ...state, updateSuccess: action.payload }
        default:
            return state;
    }
}
